var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"size":_vm.size,"color":"teal"}},[(_vm.avatar)?_c('img',{attrs:{"src":_vm.avatar}}):_c('span',{staticClass:"white--text"},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }